import styled from "styled-components";
import { Link } from "react-router-dom";

export const MainContainer = styled.div`
  margin: 15px auto;
  padding: 0 20px;
  width: 100%;
  height: 60px;
  max-width: 860px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  background-color: #d3d2d2;
  border-radius: 5px;
  @media (max-width: 910px) {
    padding: 10px;
    width: 85%;
  }
`;
export const BackLink = styled(Link)`
  display: flex;
  align-items: center;
  text-decoration: none;
  border: none;
  cursor: pointer;
`;
export const ArrowImg = styled.img`
  margin: ${({ margin }) => margin && margin};
  width: 18px;
  height: 18px;
  @media (max-width: 910px) {
    margin: ${({ margin960 }) => margin960 && margin960};
    width: 14px;
    height: 14px;
  }
`;
export const LinkText = styled.p`
  color: #808080;
  font-weight: bold;
  @media (max-width: 910px) {
    font-size: 12px;
  }
`;
export const PreviousAndNextDiv = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const NavigationButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  outline: none;
  cursor: pointer;
`;
export const SeparatorDiv = styled.div`
  margin: 0 20px;
  width: 2px;
  height: 60%;
  background-color: #808080;
  @media (max-width: 910px) {
    margin: 0 10px;
  }
`;
